"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */

/* eslint-disable */

/*
query ArtworkSaleMessageQuery(
  $artworkSlug: String!
) {
  artwork(id: $artworkSlug) {
    saleMessage
    sale {
      isAuction
      isClosed
      id
    }
    saleArtwork {
      counts {
        bidderPositions
      }
      highestBid {
        display
      }
      openingBid {
        display
      }
      id
    }
    id
  }
}
*/
var node = function () {
  var v0 = [{
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "artworkSlug",
    "type": "String!"
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "artworkSlug"
  }],
      v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "saleMessage",
    "storageKey": null
  },
      v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isAuction",
    "storageKey": null
  },
      v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isClosed",
    "storageKey": null
  },
      v5 = {
    "alias": null,
    "args": null,
    "concreteType": "SaleArtworkCounts",
    "kind": "LinkedField",
    "name": "counts",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bidderPositions",
      "storageKey": null
    }],
    "storageKey": null
  },
      v6 = [{
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "display",
    "storageKey": null
  }],
      v7 = {
    "alias": null,
    "args": null,
    "concreteType": "SaleArtworkHighestBid",
    "kind": "LinkedField",
    "name": "highestBid",
    "plural": false,
    "selections": v6
    /*: any*/
    ,
    "storageKey": null
  },
      v8 = {
    "alias": null,
    "args": null,
    "concreteType": "SaleArtworkOpeningBid",
    "kind": "LinkedField",
    "name": "openingBid",
    "plural": false,
    "selections": v6
    /*: any*/
    ,
    "storageKey": null
  },
      v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0
      /*: any*/
      ,
      "kind": "Fragment",
      "metadata": null,
      "name": "ArtworkSaleMessageQuery",
      "selections": [{
        "alias": null,
        "args": v1
        /*: any*/
        ,
        "concreteType": "Artwork",
        "kind": "LinkedField",
        "name": "artwork",
        "plural": false,
        "selections": [v2
        /*: any*/
        , {
          "alias": null,
          "args": null,
          "concreteType": "Sale",
          "kind": "LinkedField",
          "name": "sale",
          "plural": false,
          "selections": [v3
          /*: any*/
          , v4
          /*: any*/
          ],
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "concreteType": "SaleArtwork",
          "kind": "LinkedField",
          "name": "saleArtwork",
          "plural": false,
          "selections": [v5
          /*: any*/
          , v7
          /*: any*/
          , v8
          /*: any*/
          ],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0
      /*: any*/
      ,
      "kind": "Operation",
      "name": "ArtworkSaleMessageQuery",
      "selections": [{
        "alias": null,
        "args": v1
        /*: any*/
        ,
        "concreteType": "Artwork",
        "kind": "LinkedField",
        "name": "artwork",
        "plural": false,
        "selections": [v2
        /*: any*/
        , {
          "alias": null,
          "args": null,
          "concreteType": "Sale",
          "kind": "LinkedField",
          "name": "sale",
          "plural": false,
          "selections": [v3
          /*: any*/
          , v4
          /*: any*/
          , v9
          /*: any*/
          ],
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "concreteType": "SaleArtwork",
          "kind": "LinkedField",
          "name": "saleArtwork",
          "plural": false,
          "selections": [v5
          /*: any*/
          , v7
          /*: any*/
          , v8
          /*: any*/
          , v9
          /*: any*/
          ],
          "storageKey": null
        }, v9
        /*: any*/
        ],
        "storageKey": null
      }]
    },
    "params": {
      "id": null,
      "metadata": {},
      "name": "ArtworkSaleMessageQuery",
      "operationKind": "query",
      "text": "query ArtworkSaleMessageQuery(\n  $artworkSlug: String!\n) {\n  artwork(id: $artworkSlug) {\n    saleMessage\n    sale {\n      isAuction\n      isClosed\n      id\n    }\n    saleArtwork {\n      counts {\n        bidderPositions\n      }\n      highestBid {\n        display\n      }\n      openingBid {\n        display\n      }\n      id\n    }\n    id\n  }\n}\n"
    }
  };
}();

node.hash = '02a606b1af7ad3c72aa9e7fa4064577b';
var _default = node;
exports.default = _default;
//# sourceMappingURL=ArtworkSaleMessageQuery.graphql.js.map